import { atomFamily } from 'jotai-family';
import { atomWithDefault, loadable } from 'jotai/utils';
import { IObjectiveDataModel } from '../../data-models/objective.data-model';
import { fetchObjectivesForCompany } from '../queries/MaggieObjectivesQueries';

type ObjectivesValue = IObjectiveDataModel[] | null | Promise<IObjectiveDataModel[] | null>;

/**
 * The default fetches all objectives for the company. Returns `null` (without
 * fetching) when `companyId <= 0` — `ObjectivesSection` calls this atom
 * unconditionally and `selectedCompanyIdProfileAtom` defaults to `-1`.
 *
 * On fetch failure the atom resolves to `null` (rather than rejecting the
 * promise).
 *
 * Consumers using `useAtomValue` will suspend on first read; callers needing
 * a non-suspending or sync peek should use {@link objectivesByCompanyStateLoadableJ}.
 */
export const objectivesByCompanyStateJ = atomFamily((companyId: number) =>
  atomWithDefault<ObjectivesValue>(async () => {
    if (companyId <= 0) {
      return null;
    }
    try {
      return await fetchObjectivesForCompany(companyId);
    } catch (err) {
      console.error(err);
      return null;
    }
  })
);

/**
 * `loadable`-wrapped variant for callers that need to render before the
 * default resolves.
 */
export const objectivesByCompanyStateLoadableJ = atomFamily((companyId: number) =>
  loadable(objectivesByCompanyStateJ(companyId))
);
